import { render, staticRenderFns } from "./DatingStyles.vue?vue&type=template&id=8f45798a&scoped=true&"
import script from "./DatingStyles.vue?vue&type=script&lang=js&"
export * from "./DatingStyles.vue?vue&type=script&lang=js&"
import style0 from "./DatingStyles.vue?vue&type=style&index=0&id=8f45798a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f45798a",
  null
  
)

export default component.exports